<template>
  <el-dialog
    title="在线支付"
    :visible.sync="payShow"
    @closed="onClose"
    class="eldialog"
  >
    <div class="up_detail">
      <!--
      <div class="up_detail_item">
        <div class="up_detail_item_key">当前账户：</div>
        <div class="up_detail_item_val">13271390735</div>
      </div>
      <div class="up_detail_item">
        <div class="up_detail_item_key">当前账户：</div>
        <div class="up_detail_item_val">10人</div>
      </div>
      <div class="up_detail_item">
        <div class="up_detail_item_key">服务时长：</div>
        <div class="up_detail_item_val">2年</div>
      </div>-->
      <div class="up_detail_item">
        <div class="up_detail_item_key">总费用：</div>
        <div class="up_detail_item_val">
          <div>¥{{price}}</div>
<!--          <div>（已优惠80元）</div>-->
<!--          <div>支付后可开发票</div>-->
        </div>
      </div>
    </div>
    <div class="down_detail">
      <div class="left_pay_ways">
        <div class="left_pay_ways_up">
          <div class="pay_way_tip">支付方式:</div>
          <!-- 微信支付 -->
          <div class="pay_way_img" @click="wxpayWaysChoose()" :class="wxpayway">
            <div class="pay_way_img_item"></div>
            <div
              v-if="wxpayway == 'pay_way_img_isactive'"
              class="pay_way_img_item_rightdown"
            ></div>
          </div>
          <!-- 支付宝支付 -->
          <div
            class="pay_way_img pay_way_img_alipay"
            @click="alipayWaysChoose()"
            :class="alipayway"
          >
            <div class="pay_way_img_item"></div>
            <div
              v-if="alipayway == 'pay_way_img_isactive'"
              class="pay_way_img_item_rightdown"
            ></div>
          </div>
        </div>

        <div class="left_pay_ways_down">
<!--          VIP会员协议<i class="el-icon-arrow-right"></i>-->
        </div>
      </div>
      <div class="right_pay_code">
        <div class="right_pay_code_left">
          <img v-show="weixin_saoma_pic" :src="weixin_saoma_pic" alt="" class="right_pay_code_left_code" />
          <div class="pay_img_tips">
            <img src="~@/assets/images/elpaydialog/saoma.png" alt="" />
            <div class="pay_img_tips_font">
              {{ EachPayTip.ScanCodeTip }}
            </div>
          </div>
        </div>
        <img
          :src="EachPayTip.codeRightTip"
          alt=""
          class="right_pay_code_right"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "ElPayDialog",
  data() {
    return {
      outerVisible: true,
      wxpayway: "pay_way_img_isactive", //控制微信支付的触发
      alipayway: "",
      EachPayTip: {
        ScanCodeTip: "打开手机端微信扫一扫继续支付",
        codeRightTip: require("@/assets/images/elpaydialog/wx-pay-help.png"),
      },
      selectedPayType: "",
      havePayPassword: false,
      isWrapShow: this.isShow,
      can_submit: true,
      price: "",
      password: "",
      password2: "",
      types: [],
      list: [],
      weixin_saoma_pic:'',
      payShow: false,
      tt:{}
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    ids: {
      type: Array,
      default() {
        return []
      }
    },
    fromPage: {
      type: String,
      default() {
        return ''
      }
    },
    scene: {
      type: String,
      default() {
        return ''
      }
    },
  },
  watch: {
    show(val) {
//        console.log('showchange');
      this.payShow = val
      if (val) {
        var that = this; 
        console.log('payShow')
        if (that.ids.length == 0) {
          //0元 免支付
          that.onPaySuccess();
          return;
        }
        if (that.ids && that.ids.length > 0) {
          var params = {
            ids: that.ids,
            scene:that.scene
          }

          this.$api.post('/api/order/getOrderPayTypes', params, r => {
            //获取支付方式
            that.price = r.data.pay.price;
            that.types = r.data.pay.types;
            that.list = r.data.list;
            that.selectedPayType = r.data.selectedPayType;
            that.havePayPassword = r.data.havePayPassword;
              that.$api.post('/api/order/orderPay', {
                orders:that.list,
                type:'weixinsaoma'
              }, r2 => {
                //获取支付方式
                that.weixin_saoma_pic = r2.data.data;
              });
              console.log('检查是否支付成功')
              that.tt = setInterval(() =>{
                  //检查是否支付成功 
                  that.$api.post('/api/order/checkorderpayed', { 
                    id: that.ids[0],
                    scene:that.scene
                  }, r => { 
                    that.onPaySuccess();
                  },r =>{

                  });
              },1000)

          });

        }
      }
    }
  },
  mounted: function () {
    this.$api.get('/api/weixin/jsConfig', {
      "url" : sessionStorage.getItem("wx_entry_url")
    }, r1 => {
      wx.config(r1.data);
    });
  },
  methods: {
    onClose() {
      this.$emit("onPayClose", {})
      clearInterval(this.tt);
    },
    onPaySuccess() {
      this.$emit("onPaySuccess", {})
      clearInterval(this.tt);
    },
    onPayError() {
      this.$emit("onPayError", {})
      clearInterval(this.tt);
    },
    toPay() {
      if (this.can_submit == false) {
//              this.$toast.center('您已经提交过支付请求了!');
//              this.jump();
        return;
      }
      this.can_submit = false;
      var that = this;
      let params = {
        "orders": that.list,
        "type": that.selectedPayType,
        "password": that.password,
        "password2": that.password2,
      };
      console.log('pay');
      that.$api.post('/api/order/orderpay', params, r2 => {
        if (that.selectedPayType == 'weixin') {
          //获取微信支付信息
          wx.chooseWXPay({
            timestamp: r2.data.data.timestamp,
            nonceStr: r2.data.data.nonceStr,
            package: r2.data.data.package,
            signType: r2.data.data.signType,
            paySign: r2.data.data.paySign,
            success: function (res3) {
              that.onPaySuccess();
            },
            cencel: function (res) {
              console.log(res);
              that.onPayError();
            },
            fail: function (res) {
              console.log(res);
              that.onPayError();
            }
          })
        } else if (that.selectedPayType == 'weixinh5') {
          location.href = r2.data.data.url;
        } else if(that.selectedPayType == 'weixinapp'){
          appEvent({
            name: 'weixinAppPay',
            query: r2.data.data
          });
          Dialog.setDefaultOptions({
            'confirmButtonText':'支付成功',
            'cancelButtonText':'支付失败',
          })
          Dialog.confirm({
            title: '支付订单',
            message: '请在微信中完成支付'
          }).then(() => {
            that.onPaySuccess();
          }).catch(() => {
            that.onPayError();
          });
        }else if(that.selectedPayType == 'alipayapp'){
          //                alert(r2.data.data);
          appEvent({
            name: 'alipayAppPay',
            query: r2.data.data
          });
          Dialog.setDefaultOptions({
            'confirmButtonText':'支付成功',
            'cancelButtonText':'支付失败',
          })
          Dialog.confirm({
            title: '支付订单',
            message: '请在支付宝中完成支付'
          }).then(() => {
            that.onPaySuccess();
          }).catch(() => {
            that.onPayError();
          });
          //                location.href= r2.data.data.url;
        }else if(that.selectedPayType == 'alipayapp2'){
          //                alert(r2.data.data);
          appEvent({
            name: 'alipayAppPay',
            query: r2.data.data
          });
          Dialog.setDefaultOptions({
            'confirmButtonText':'支付成功',
            'cancelButtonText':'支付失败',
          })
          Dialog.confirm({
            title: '支付订单',
            message: '请在支付宝中完成支付'
          }).then(() => {
            that.onPaySuccess();
          }).catch(() => {
            that.onPayError();
          });
          //                location.href= r2.data.data.url;
        }else {
          that.onPaySuccess();
        }
      }, r2 => {
        that.$toast(r2.msg);
        that.can_submit = true;
        that.onPayError();
      });
    },
    wxpayWaysChoose() {
      if (this.wxpayway != "pay_way_img_isactive") {
        this.wxpayway = "pay_way_img_isactive";
        this.alipayway = "";

        this.EachPayTip.codeRightTip = require("@/assets/images/elpaydialog/wx-pay-help.png");
        this.EachPayTip.ScanCodeTip = "打开手机端微信扫一扫继续支付";
      }
    },
    alipayWaysChoose() {
      let that = this;
      if (this.alipayway != "pay_way_img_isactive") {
        this.alipayway = "pay_way_img_isactive"
        this.wxpayway = "";

        console.log('alipayWaysChoose');
        

        this.EachPayTip.codeRightTip = require("@/assets/images/elpaydialog/alipay-guide.png");
        this.EachPayTip.ScanCodeTip = "打开手机端微信扫一扫继续支付";

        that.$api.post('/api/order/orderpay', {
            "orders": that.list,
            "type": 'alipaypc',
            "password": that.password,
            "password2": that.password2,
        }, r => {
          console.log(r);
          window.open(r.data.data);
        }, r =>{
          console.log(r);
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.eldialog {
  overflow: hidden;
  border-radius: 4px;

  /deep/.el-dialog {
    border-radius: 4px;
    /deep/.el-dialog__body {
      // padding-top: 12px;
    }
  }
  /deep/.el-dialog__header {
    padding: 0;
    // position: relative;
    background: #0175c2;
    // border-radius: 4px 4px 0 0;
    // overflow: hidden;
    height: 40px;
    // line-height: 40px;
    // text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .el-dialog__title {
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%, -50%);
      font-size: 20px;
      color: #fff;
    }
    .el-dialog__headerbtn {
      top: auto;
      // position: absolute;
      // top: 50%;
      // transform: translateY(-50%);
      .el-dialog__close {
        font-size: 25px;
        color: #fff;
      }
    }
  }
  .up_detail {
    display: flex;
    flex-direction: column;
    padding: 0 0 3px 0;
    border-bottom: 1px dashed #e7e7e7;
    .up_detail_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-family: "Microsoft YaHei", Arial, sans-serif;
      font-size: 14px;
      color: #333;
      margin: 6px 0 12px 0px;
      box-sizing: border-box;
      .up_detail_item_key {
        width: 70px;
      }
      .up_detail_item_val:last-child {
        display: flex;
        align-items: center;
        justify-content: center;
        div:nth-child(1) {
          padding-right: 4px;
          font-weight: bold;
          color: #ff3a30;
          font-size: 24px;
          line-height: 24px;
        }
        div:nth-child(2) {
          color: #ff3a30;
          line-height: 28px;
        }
        div:nth-child(3) {
          color: #ff3b30;
          position: relative;
          //   height: 28px;
          padding: 3px 6px;
          border: 1px solid #ffeceb;
          line-height: 1.48;
          background-color: #ffeceb;
          margin-left: 3px;
          &::after {
            content: "";
            border-width: 6px 6px 6px 0;
            border-color: transparent;
            border-right-color: #ffeceb;
            position: absolute;
            left: -7px;
            top: 8px;
            border-style: solid;
          }
        }
      }
    }
  }
  .down_detail {
    display: flex;
    flex-direction: row;
    height: 230px;
    margin: 16px 0 0 0;
    .left_pay_ways {
      width: 152px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 230px;
      .left_pay_ways_up {
        .pay_way_img {
          width: 126px;
          height: 46px;
          border: 1px solid #e4e4e4;
          border-radius: 2px;
          box-sizing: content-box;
          margin: 12px 0 0 0;
          position: relative;
          z-index: 0;
          .pay_way_img_item {
            width: 108px;
            height: 35px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            box-sizing: content-box;

            background: url("~@/assets/images/elpaydialog/微信支付.png")
              no-repeat center center;
            background-size: 100% 100%;
          }
          .pay_way_img_item_rightdown {
            position: absolute;
            bottom: -1px;
            right: -1px;
            width: 24px;
            height: 24px;
            background: url("~@/assets/images/elpaydialog/pay-way-active-angle.png") no-repeat center center;
            background-size: 100% 100%;
            z-index: 5000;
          }
        }
        .pay_way_img_alipay {
          .pay_way_img_item {
            background: url("~@/assets/images/elpaydialog/支付宝支付.png")
              no-repeat center center;
            background-size: 100% 100%;
          }
        }
        .pay_way_img_isactive {
          width: 124px;
          height: 44px;
          box-sizing: content-box;
          border: 2px solid #0084ff;
        }
      }
      .left_pay_ways_down {
        font-size: 12px;
        color: #999;
        &:hover {
          cursor: pointer;
          color: #fa8430;
        }
      }
    }
    .right_pay_code {
      flex: 1;
      background: #f9f9f9;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .right_pay_code_left {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .right_pay_code_left_code {
          width: 134px;
          height: 134px;
          background: pink;
          border: 0px;
          outline: none;
        }
        .pay_img_tips {
          margin: 8px 0 0 0;
          img {
            width: 25px;
            height: 25px;
            margin-right: 6px;
          }
          .pay_img_tips_font {
            width: 91px;
            display: inline-block;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 1px;
            color: #666;
            text-align: center;
          }
        }
      }
      .right_pay_code_right {
        width: 135px;
        height: 126px;
        margin: 0 0 0 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ElPayDialog.vue?8021d014